import { loraSensorOn, loraSensorOff, airOn, airOff, coOn, coOff, IconAlarm, monitoringOff, monitoringOn } from '@assets/images/main/index';
import {
  Icon3d3d,
  Icon3dAlert,
  Icon3dCheck,
  Icon3dCycle,
  Icon3dDetect,
  Icon3dLocation,
  Icon3dMap2,
  Icon3dMeter,
  Icon3dSchedule,
  Icon3dServer,
  IconDownload,
} from '@assets/images/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import {
  iotBannerBg,
  iotBannerProduct,
  iotScreenshot1D,
  iotScreenshot1M,
  iotScreenshot1T,
  iotScreenshot2D,
  iotScreenshot2M,
  iotScreenshot2T,
  iotScreenshot3D,
  iotScreenshot3M,
  iotScreenshot3T,
} from '@assets/images/main/sensor';
import { IconAirQualityInv, IconBellInv, IconCo2Inv, IconLoraSensorInv } from '@assets/images/main/icon';

export default {
  banner: {
    title: 'Dù là thiết bị phức tạp hay dữ liệu đa dạng,<br/>với ORBRO, tất cả hoạt động như một thể thống nhất.',
    desc: 'Nhiệt độ, độ ẩm, chất lượng không khí, áp suất, CO₂, phát hiện xâm nhập, điều khiển nguồn điện, chuông báo an toàn, v.v...<br/>Dữ liệu IoT tại khu vực được thu thập và hiển thị trực tiếp theo thời gian thực qua ORBRO OS.',

    schemeTitle: 'Orbro đã chuẩn bị các cảm biến phù hợp, hoàn hảo cho môi trường công nghiệp.',
    bgImg: iotBannerBg,
    productImg: iotBannerProduct,
  },

  func: {
    title: 'Tìm hiểu thêm tính năng',
    desc: 'Khám phá các tính năng đa dạng của cảm biến.',

    data: [
      {
        img: Icon3dMap2,
        title: 'Giám sát trạng thái cảm biến theo thời gian thực',
        desc: 'Có thể theo dõi trạng thái hoạt động của cảm biến, mức pin còn lại và cường độ tín hiệu kết nối trực tiếp trên ORBRO OS theo thời gian thực.',
      },
      {
        img: Icon3dCheck,
        title: 'Hiển thị vị trí lắp đặt cảm biến trên bản đồ',
        desc: 'Vị trí lắp đặt cảm biến được hiển thị trực quan trên bản đồ hoặc sơ đồ mặt bằng, giúp theo dõi tình trạng theo từng khu vực trong nháy mắt.',
      },
      {
        img: Icon3dSchedule,
        title: 'Xem lịch sử sự kiện và nhật ký cảnh báo',
        desc: 'Các sự kiện bất thường và lịch sử cảnh báo được hiển thị theo dòng thời gian, hỗ trợ phân tích nguyên nhân sự cố.',
      },
      {
        img: Icon3dLocation,
        title: 'Quản lý nhóm cảm biến theo khu vực',
        desc: 'Cảm biến có thể được nhóm theo khu vực lắp đặt hoặc mục đích sử dụng, giúp quản lý trực quan ngay trên bảng điều khiển.',
      },
      {
        img: Icon3dAlert,
        title: 'Phát hiện bất thường và cài đặt ngưỡng',
        desc: 'Cài đặt ngưỡng cho từng cảm biến, hệ thống sẽ tự động phát hiện và gửi thông báo khi giá trị vượt quá ngưỡng.',
      },
      {
        img: Icon3dAlert,
        title: 'Cài đặt điều kiện thông báo theo khu vực',
        desc: 'Điều chỉnh độ nhạy thông báo theo khu vực, cho phép thiết lập các điều kiện nhạy hơn cho những khu vực có nguy cơ cao.',
      },
      {
        img: IconDownload,
        title: 'Lưu trữ và tải xuống lịch sử dữ liệu',
        desc: 'Dữ liệu đo lường và lịch sử sự kiện được lưu tự động, có thể xuất ra định dạng CSV hoặc Excel.',
      },
      {
        img: Icon3dServer,
        title: 'Tích hợp hệ thống bên ngoài (API)',
        desc: 'Cung cấp API để kết nối với các hệ thống như kiểm soát ra vào, điều khiển thiết bị, và hỗ trợ tự động hóa dựa trên sự kiện kích hoạt.',
      },
    ],
  },

  bannerData: [
    {
      icon: loraSensorOn,
      iconInv: IconLoraSensorInv,
      iconOff: loraSensorOff,
      image: '',
      iconText: 'Cảm biến LoRA',
      sub: 'New',
      link: '/vi/iot/LoRASensor',
    },
    {
      icon: coOn,
      iconInv: IconCo2Inv,
      iconOff: coOff,
      image: '',
      iconText: 'Máy đo CO₂',
      sub: 'New',
      link: '/vi/iot/co2',
    },
    {
      icon: airOn,
      iconInv: IconAirQualityInv,
      iconOff: airOff,
      image: '',
      iconText: 'Máy đo chất lượng không khí',
      sub: 'New',
      link: '/vi/iot/air',
    },
    {
      icon: monitoringOn,
      iconInv: IconBellInv,
      iconOff: monitoringOff,
      image: '',
      iconText: 'Chuông báo khẩn cấp',
      sub: '',
      link: '/vi/iot/bell',
    },
  ],

  screenShot: [
    {
      title: 'Bảng điều khiển tích hợp thời gian thực hiển thị toàn bộ cảm biến<br/>trong một màn hình',
      desc: 'Dữ liệu từ nhiều cảm biến IoT được trực quan hóa theo thời gian thực trên ORBRO OS,<br/>cho phép quản lý vị trí và thông tin cảm biến một cách trực quan trên cùng một giao diện.',
      img: {
        desktop: iotScreenshot1D,
        tablet: iotScreenshot1T,
        mobile: iotScreenshot1M,
      },
    },
    {
      title: 'Biểu đồ dữ liệu cảm biến theo thời gian',
      desc: 'Giá trị đo từ từng cảm biến được hiển thị theo biểu đồ thời gian,<br/>giúp nhanh chóng phát hiện sự thay đổi môi trường và dấu hiệu bất thường',
      img: {
        desktop: iotScreenshot2D,
        tablet: iotScreenshot2T,
        mobile: iotScreenshot2M,
      },
    },
    {
      title: 'Cảnh báo ngay khi phát hiện dấu hiệu bất thường',
      desc: 'Khi cảm biến vượt ngưỡng cài đặt hoặc phát hiện trạng thái bất thường,<br/> ORBRO OS sẽ ngay lập tức gửi cảnh báo đến quản trị viên để hỗ trợ xử lý kịp thời',
      img: {
        desktop: iotScreenshot3D,
        tablet: iotScreenshot3T,
        mobile: iotScreenshot3M,
      },
    },
  ],

  FAQ: [
    {
      title: 'Dữ liệu cảm biến được cập nhật thường xuyên như thế nào?',
      description: 'Thiết lập mặc định là mỗi 1–5 phút, nhưng tùy theo loại cảm biến, cũng có thể hỗ trợ truyền dữ liệu theo thời gian thực.',
    },
    {
      title: 'Hệ thống có hoạt động trong môi trường không có mạng không?',
      description: 'Một số cảm biến có khả năng lưu trữ dữ liệu cục bộ và truyền dữ liệu khi mạng được khôi phục.',
    },
    {
      title: 'Có thể lắp đặt nhiều cảm biến cùng lúc không?',
      description: 'ORBRO OS được thiết kế để kết nối và quản lý nhiều cảm biến cùng lúc một cách hiệu quả.',
    },
    {
      title: 'Có thể tích hợp với thiết bị bên ngoài không?',
      description: 'Thông qua API, hệ thống có thể tích hợp linh hoạt với các thiết bị như hệ thống điều khiển, hệ thống kiểm soát ra vào, v.v.',
    },
    {
      title: 'Pin cảm biến sử dụng được bao lâu?',
      description:
        'Tùy theo sản phẩm, nhưng cảm biến LoRa thường có thời gian sử dụng trung bình từ 6 tháng đến hơn 1 năm. Trạng thái pin cũng có thể được theo dõi theo thời gian thực.',
    },
    {
      title: 'Tất cả cảm biến có liên kết với ORBRO OS không?',
      description:
        'Tất cả thiết bị được chứng nhận bởi ORBRO đều tự động tích hợp. Ngoài ra, một số cảm biến của hãng khác sử dụng giao thức như Modbus, RS-485 cũng có thể tích hợp được.',
    },
    {
      title: 'Có nhận được thông báo khi cảm biến gặp sự cố không?',
      description: 'Vâng. Hệ thống sẽ tự động phát hiện các tình huống bất thường như mất tín hiệu, pin yếu và gửi cảnh báo ngay lập tức.',
    },
    {
      title: 'Có thể gửi cảnh báo cho nhiều người cùng lúc không?',
      description: 'Vâng, có thể. Có thể thiết lập nhóm người nhận cảnh báo theo phòng ban hoặc theo vai trò.',
    },
  ],
};
